module.exports = __webpack_public_path__ + "img/progress_mobile_fr@2x.8202da94.png";